import LeftRightContentText from "../components/LeftRightContentText";
import { useAppContext } from "../_context";
import Benefits from "../components/Pages/Careers/Benefits";
import CareerEmailUs from "../components/Pages/Careers/CareerEmailUs";
import Hero from "../components/Pages/Careers/Hero";
import OpenRoles from "../components/Pages/Careers/OpenRoles";
import TeamSuccess from "../components/Pages/Careers/TeamSuccess";
import Testimonials from "../components/Testimonials";
import { useEffect, useState } from "react";
import Contentful from "../utilities/Contentful";
import { getLinkToContentfulMedia } from "../utilities/Helpers";
import Head from "next/head";

const Careers = () => {
  const [{ tx }] = useAppContext();
  const [testimonials, setTestimonials] = useState([]);
  const [jobSpecs, setJobSpecs] = useState([]);

  useEffect(() => {
    async function getTestimonials() {
      const results = await new Contentful().fetchValueOnly({
        content_type: "testimonial",
        "fields.page": "Careers",
      });

      setTestimonials(
        results.map((item) => {
          return {
            avatar_url: getLinkToContentfulMedia(item, "avatar"),
            name: item.name,
            role: item.role,
            description: item.testimonial,
          };
        }),
      );
    }

    async function getOpenRoles() {
      const results = await new Contentful().fetchValueOnly({
        content_type: "jobSpec",
      });

      setJobSpecs(results);
    }

    getTestimonials();
    getOpenRoles();
  }, []);

  return (
    <>
      <Head>
        <title>RacketPal - {tx["Careers"]}</title>
      </Head>
      <Hero />
      <TeamSuccess />
      <LeftRightContentText
        title={tx["Perks & Benefits"]}
        className="section-padding-top">
        <p>
          {
            tx[
              "In a world of a million opportunities, we understand that a job isn’t just a job, it’s a lifestyle. And choosing the right place to work means more than a salary or job title."
            ]
          }
        </p>
        <p className="mb-0">
          {tx["We listen to our team and prioritise what’s important to them."]}
        </p>
      </LeftRightContentText>
      <Benefits />
      <OpenRoles jobSpecs={jobSpecs} />
      <CareerEmailUs />
      <Testimonials
        className="section-padding-top"
        grey={false}
        carouselItems={testimonials}
        title={tx["Why work for RacketPal?"]}
        subtitle={
          tx[
            "Good question. And one we could answer, but we’d rather the team told you themselves. Straight from the horses’ mouths..."
          ]
        }
      />
    </>
  );
};

export default Careers;
